import {FormattedMessage} from "react-intl";
import {Props as FormattedMessageProps} from "react-intl/lib/src/components/message";
import {IntlIdsMap, IntlMessageIdTypes} from "./_base";
import React from "react";

export function IntlMsg(props: Omit<FormattedMessageProps, 'id'> & { id: IntlMessageIdTypes }) {
    const {id, ...rest} = props;
    return <FormattedMessage id={IntlIdsMap[id]} {...rest}/>
}